import React from 'react'
import PropTypes from "prop-types";
import ContractNoticeForm from "./contractNotice/ContractNoticeForm";
import XmlUzpPresidentPaper from "./xmlUzpPresidentPaper/XmlUzpPresidentPaper";


function NationalNoticePage(
    {
        demandId,
        formType
    }) {

    switch (formType) {
        case "xmlUzpPresidentPaper":
            return <XmlUzpPresidentPaper demandId={demandId} />
        default:
            return <ContractNoticeForm demandId={demandId}/>
    }
}

NationalNoticePage.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    formType: PropTypes.string.isRequired
};

export default NationalNoticePage;
